/**
 * @generated SignedSource<<843a2b49c96f77be27b264dc14fc8487>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Country_geographySalesforce$data = {
  readonly countries: ReadonlyArray<{
    readonly abbreviation: string | null;
    readonly name: string | null;
  } | null> | null;
  readonly " $fragmentType": "Country_geographySalesforce";
};
export type Country_geographySalesforce$key = {
  readonly " $data"?: Country_geographySalesforce$data;
  readonly " $fragmentSpreads": FragmentRefs<"Country_geographySalesforce">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Country_geographySalesforce",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "countries",
      "kind": "LinkedField",
      "name": "countries",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "abbreviation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GeographySalesforce",
  "abstractKey": null
};

(node as any).hash = "de700994e3937f6fb06c306f238d7ad7";

export default node;
